import React from 'react';

import {type SettingType} from '../../../../services/analytics/workspaceSettingsEvents';
import {type SettingOverrideCounts} from '../../../../state/views/workspaceSettings/settingOverrideUtils';
import {ClearSettingsRow} from '../components/ClearSettingsRow';
import {SettingToggleRow} from '../components/SettingToggleRow';
import {type ClearSettingFnType} from '../hooks/useSettingOverrides';
import {
  type ExcludeOutliersValues,
  type LinePlotSettings,
  type SettingLevel,
} from '../types';
import {areOutliersExcluded} from '../utils';

export const LinePlotExcludeOutliers = ({
  clearSetting,
  disabled = false,
  displayValues,
  numOverrides,
  settingLevel,
  trackSetting,
  updateSetting,
  values,
}: {
  clearSetting?: ClearSettingFnType;
  disabled?: boolean;
  displayValues: {
    excludeOutliers: ExcludeOutliersValues | undefined;
  };
  numOverrides: SettingOverrideCounts;
  settingLevel: SettingLevel;
  values: {
    excludeOutliers: ExcludeOutliersValues | undefined;
  };
  trackSetting: (setting: SettingType, value: string | undefined) => void;
  updateSetting: (settings: Partial<LinePlotSettings>) => void;
}) => {
  return (
    <>
      <SettingToggleRow
        clearSetting={clearSetting}
        description="Exclude extreme outliers when scaling charts"
        disabled={disabled}
        displayValue={
          !disabled && areOutliersExcluded(displayValues.excludeOutliers)
        }
        label="Outliers"
        onCheckedChange={(newValue: ExcludeOutliersValues) => {
          updateSetting({
            excludeOutliers: newValue ? 'exclude-outliers' : 'include-outliers',
          });
          trackSetting(
            'excludeOutliers',
            newValue ? 'exclude-outliers' : 'include-outliers'
          );
        }}
        emptySettings={{excludeOutliers: undefined}}
        numOverrides={numOverrides}
        settingKey="excludeOutliers"
        settingLevel={settingLevel}
        value={
          values.excludeOutliers == null
            ? undefined
            : areOutliersExcluded(displayValues.excludeOutliers)
        }
      />
      {/* Note: we are not using ClearSettingsRow(s) because it doesn't follow the same clearSetting function pattern. */}
      {numOverrides?.panels != null &&
        numOverrides?.panels?.excludeOutliers > 0 && (
          <div className="flex-end">
            <ClearSettingsRow
              settingKey="excludeOutliers"
              settingLevel="panel"
              count={numOverrides?.panels?.excludeOutliers}
              clearSetting={() => {
                clearSetting?.('panel', 'excludeOutliers', {
                  excludeOutliers: undefined,
                });
                clearSetting?.('panel', 'ignoreOutliers', {
                  // @ts-expect-error - ignoreOutliers is deprecated
                  ignoreOutliers: undefined,
                });
                clearSetting?.('panel', 'showMinMaxOnHover', {
                  // @ts-expect-error - showMinMaxOnHover is deprecated
                  showMinMaxOnHover: undefined,
                });
              }}
            />
          </div>
        )}
    </>
  );
};
